// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".share-popup .btn[data-v-8437bb3c],.share-popup input.default[data-v-8437bb3c]{margin:5px 0}.share-popup p[data-v-8437bb3c]{font-weight:700;font-size:.9rem;margin:10px 0;text-align:center}", ""]);
// Exports
module.exports = exports;
